import { COLORS, SCREEN_MD } from "shared/consts";
import { toEm, toRem } from "shared/helpers";
import styled, { css } from "styled-components";

type WrapperProps = {
  $isMobile?: boolean;
  $disabled?: boolean;
}
export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  gap: ${toRem(2)};
  --max-width: ${toRem(144)};
  pointer-events: auto;

  @media (width < ${toEm(1200)}){
    --max-width: max-content;
  }

  .dropdown-menu-root {
    //flex: 0 0 var(--max-width);
    margin-right: 15px;
    //margin-right: 20px;
    @media (width >= ${toEm(SCREEN_MD)}){
      max-width: ${toRem(120)};
    }
  }

  .input {
    border-radius: 0 ${toRem(8)} ${toRem(8)} 0;
    min-width: 0;
    width: auto;
    max-width: var(--max-width);
    transition: border-radius 0.3s ease 0s;
    flex-direction: row;
    --input-primary-border-color-hover: transparent;
    --input-m-inputvalue-font: 500 14px/20px var(--font-family);
    --input-primary-border-color-default: transparent;
    --input-primary-border-color-focus: ${COLORS.BG.PAGE};
    ${props => !props.$isMobile ? css`
    --input-primary-bg-color-default: ${COLORS.ACCENT.CONTAINER_DEFAULT};
    --input-primary-inputvalue-color-default: ${COLORS.ACCENT.DEFAULT};
    --input-primary-bg-color-hover: ${COLORS.ACCENT.CONTAINER_HOVER};
    --input-primary-bg-color-focus: ${COLORS.ACCENT.CONTAINER_HOVER};
    --input-primary-border-color-focus: ${COLORS.BG.PAGE};
    ` : `
      --input-s-height: ${toRem(28)};
      --input-primary-bg-color-default: ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
      --focus-soft-color: transparent;
    `}
    &:focus-within {
      border-radius: ${toRem(8)};
    }

    &.input--size-s {
      margin-top: 0;
    }
  }

  .input .input__field {
    width: max-content;
    margin: 0;
    padding: 0 ${toRem(16)};
    max-width: calc(var(--max-width) - ${toRem(20)});
    flex: 0 0 calc(var(--max-width) - ${toRem(20)});
    font-weight: 500;
    align-self: stretch;
    height: auto;
  }

  .input__suffix {
    display: none;
  }

  .dropdown-menu {
    min-width: ${toRem(186)};
    @media (width >= ${toRem(768)}){
      margin-left: ${toRem(-19)} !important;
    }
  }

  ${props => props.$disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `}
`

type IconProps = {
  $isMobile?: boolean;
  $direction?: "ASC" | "DESC";
}
export const Icon = styled.div<IconProps>`
  display: flex;
  justify-content:center;align-items: center;
  border-radius: ${toRem(8)} 0 0 ${toRem(8)};
  background-color: ${props => props.$isMobile ? COLORS.NEUTRAL.CONTAINER_DEFAULT : COLORS.ACCENT.CONTAINER_DEFAULT};
  flex: 0 0 ${toRem(36)};
  cursor: pointer;
  pointer-events: auto;

  ${props => props.$isMobile && css`
  `}

  svg {
    transition: transform 0.2s ease;
    transform: rotate(${props => props.$direction === "ASC" ? 180 : 0}deg);
  }
`